var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog"}},[_c('Breadcrumb',{attrs:{"pages":this.pages}}),_c('GenericPage',{attrs:{"page":_vm.page,"paging":_vm.paging,"pageSize":_vm.pageSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }